import { usePunditUserContext } from "@/react/contexts";

export const useExperimentEnabled = (flagName: string): boolean => {
  const { experimentation } = usePunditUserContext();

  const experiments = experimentation?.experiments ?? [];

  return experiments.some(exp => exp.flag_name === flagName);
};
